import { Component } from '@angular/core';

@Component({
  selector: 'app-content-card6',
  imports: [],
  templateUrl: './content-card6.component.html',
  styleUrl: './content-card6.component.scss'
})
export class ContentCard6Component {

}
